import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=eede1eac&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eede1eac')) {
      api.createRecord('eede1eac', component.options)
    } else {
      api.reload('eede1eac', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=eede1eac&", function () {
      api.rerender('eede1eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iBD7Wmt8UMNZ/JS/comp/FavElement.vue"
export default component.exports